import $ from 'jquery';

import DDTemplates from './DDTemplates';
import Menu from './Menu';
import Drupal from './Drupal';
import Header from './Header';
import Sticky from './Sticky';
import Gallery from './Gallery';
import Toolbar from './Toolbar';
import MobileMenu from './MobileMenu';
import SmartFooter from './SmartFooter';
import CalendarList from './CalendarList';
import CalendarFilters from './CalendarFilters';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';
import StripLink from './StripLink';
import Viewport from './Viewport';
import Mission from './Mission';
import Hero from './Hero';
import Banner from './Banner';
import TwitterFeed from './TwitterFeed';
import Connect from './Connect';
import Events from './Events';
import Explore from './Explore';
import CustomTabs from './CustomTabs';

// Add the theme behaviors
Drupal.behavior((context) => {
  // Helpers
  const $body = $(document.body, context);

  // DD Template Behaviors
  // eslint-disable-next-line no-new
  new DDTemplates(context);

  // Mission
  $('.mission.block .quotes', context).each((i, element) => {
    if (!element.Mission) {
      element.Mission = new Mission(element);
    }
  });

  // Hero
  $('#block-views_blocks-term-block_1-4', context).each((i, element) => {
    if (!element.Hero) {
      element.Hero = new Hero(element);
    }
  });

  // Banner
  $('.banner.block', context).each((i, element) => {
    if (!element.Banner) {
      element.Banner = new Banner(element);
    }
  });

  // Upcoming Events

  $('.events.block', context).each((i, element) => {
    if (!element.Events) {
      element.Events = new Events(element);
    }
  });

  $('#block-views-calendar_feed-block_1 .event-date', context).each((i, element) => {
    if ($(element).text() === '12:00am') {
      $(element).hide();
    }
  });

  // Twitter Feed

  $('.twitter-feed', context).each((i, element) => {
    if (!element.TwitterFeed) {
      element.TwitterFeed = new TwitterFeed(element);
    }
  });

  // Stay Connected

  $('#block-views_blocks-term-block_1-8', context).each((i, element) => {
    if (!element.Connect) {
      element.Connect = new Connect(element);
    }
  });

  // Fix our damn menus from displaying orphaned children
  $('.primary-navigation, .term-nav', context).each((i, element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Sticky sidebars
  $('.page-sidebar', context).each((i, element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // Article displays
  $('body.wt145', context).each((i, element) => {
    if (!element.Explore) {
      element.Explore = new Explore();
    }
    // Move bundled content to sidebar.
    $('.bundled-posts.block', context).appendTo('.page-right .page-sidebar');
  });


  // Main/Primary Site Navigation
  $('#block-nice_menus-3', context).each((i, element) => {
    if (!element.Menu && !element.MobileMenu) {
      element.Menu = new Menu(element);
      element.MobileMenu = new MobileMenu(element);
    }
  });

  // Controls the states of the menu and search states
  $('.toolbar', context).each((i, element) => {
    if (!element.Toolbar) {
      element.Toolbar = new Toolbar(element);
    }
  });

  // Controls the page overlay display
  $('.overlay', context).bind('click', () => {
    $body.removeClass('menu-active search-active');
  });

  // Fixed Header using Headroom.js
  $('.headroom', context).each((i, element) => {
    if (!element.Header) {
      element.Header = new Header(element);
    }
  });

  // Footerlinks (strip heading link)
  $('.footerlinks .node-header a', context).each((i, element) => {
    if (!element.StripLink) {
      element.StripLink = new StripLink(element);
    }
  });

  // Footerlinks (mobile accordions)
  $('.footerlinks .title', context).bind('click', (event) => {
    if (Viewport.mobileState) {
      event.preventDefault();
      $(event.currentTarget).closest('.node').toggleClass('expand');
    }
  });

  // Smart Footer
  $('.page-footer', context).each((i, element) => {
    const $footprint = $('.footprint', context);
    if (!element.SmartFooter && $footprint.length) {
      element.SmartFooter = new SmartFooter(element, $footprint);
    }
  });

  // Term Navigation
  $('.term-nav', context).each((i, element) => {
    if (!element.TermNavigation) {
      element.TermNavigation = new TermNavigation(element);
    }
  });

  // Hack for bundled content displays within a Article post type
  $('.wt145 .bundled-posts .node', context).each((i, element) => {
    $('.associated.node-item', element).insertBefore($('.node-header', element));
  });

  // Photo Galleries
  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.Gallery) {
      element.Gallery = new Gallery(element);
    }
  });

  // Calendar of Events View
  $('.calendar-feed', context).each((i, element) => {
    if (!element.CalendarList) {
      element.CalendarList = new CalendarList(element);
    }
  });

  // Calendar Filters for both views
  $('.calendar-feed, .view-grid-calendar', context).each((i, element) => {
    if (!element.CalendarFilters) {
      element.CalendarFilters = new CalendarFilters(element, {
        useFilters: true,
        filters: {
          All: 2,
          Trainings: 314,
          'Special Dates': 315,
        },
      });
    }
  });

  // Custom Tabs
  $('.tab-posts', context).each((i, element) => {
    if (!element.CustomTabs) {
      element.CustomTabs = new CustomTabs(element);
    }
  });

  // Cleanup empty calendar filters
  const hasFilters = $('.view-grid-calendar ul.filters li.filter', context).length;
  if (!hasFilters) {
    $('.view-grid-calendar ul.filters', context).remove();
  }

  // Add Sitemap output using the digitaldcore.js function
  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }

  $('#edit-field-date-value-value-year-wrapper select option:first-child').text('All Years');
});
